import { LOGINURL } from "@/assets/scripts/api";
import axios from "axios";
const baseURL = "//bar.xkw.com/";
const httpInstance = axios.create({
  withCredentials: true,
  timeout: 1000 * 60 * 10,
  maxContentLength: Infinity,
});
httpInstance.interceptors.response.use(
  (resp) => {
    if (resp.data.code === 10001) {
      return (window.location.href = LOGINURL);
    }
    return resp;
  },
  err => {
    return Promise.reject(err);
  }
);
const http = {
  put (url, data) {
    return this.request({
      method: "PUT",
      url,
      data,
    });
  },
  delete (url, data) {
    return this.request({
      method: "DELETE",
      url,
      params: data,
    });
  },
  get (url, data) {
    return this.request({
      method: "GET",
      url,
      params: data,
    });
  },
  post (url, data, headers) {
    return this.request({
      method: "POST",
      url,
      data,
      headers: headers || {
        "content-type": "application/json",
      },
    });
  },
  postDown (url, data, headers) {
    return this.request({
      method: "POST",
      url,
      data,
      headers: headers || {
        "Content-Type": "multipart/form-data",
      },
      // responseType: 'arraybuffer'
    });
  },
  async request (options) {
    const defaultOptions = {
      baseURL,
      method: "POST",
    };
    const finalOptions = Object.assign(defaultOptions, options);
    let result = {};
    try {
      result = await httpInstance.request(finalOptions);
    } catch ({ request, response, config }) {
      return null;
    }
    // 各种类型均需返回data
    return result.data;
  },
};
export default http;
